// GENERATED FILE — do not edit by hand.
// Produced by dockerize-cms/ai-cms/scripts/gen-image-variants.py
// (phase 5 of ai-cms/reports/pagespeed-plan-2026-09-14.md).
//
// Every key is a bucket object path under
// https://storage.googleapis.com/getlife-bucket-1/ that HAS pre-generated
// responsive variants at public/<prefix>/w<width>/<name>. `widths` lists only
// the variants that actually exist (originals narrower than a breakpoint are
// never upscaled), and width/height are the intrinsic dimensions of the
// original, used for the `width`/`height` attributes that prevent CLS.
//
// Regenerate with:
//   ai-cms/scripts/gen-image-variants.py --ts-out gatsby/src/resources/imageVariants.ts

export interface ImageVariantEntry {
  widths: number[];
  width: number;
  height: number;
}

export const VARIANT_WIDTHS = [400, 800, 1200] as const;

export const imageVariants: Record<string, ImageVariantEntry> = {
  "public/image/image-strapi/familia-despreocupada-divirtiendose-mientras-muda-nuevo-hogar.webp": {
    widths: [400, 800],
    width: 1120,
    height: 1110,
  },
  "public/life5-web/card-cancer.webp": {
    widths: [400, 800],
    width: 1056,
    height: 459,
  },
  "public/life5-web/card-familia.webp": {
    widths: [400, 800],
    width: 1056,
    height: 459,
  },
  "public/life5-web/familia_seg-vida-1.webp": {
    widths: [400, 800],
    width: 1100,
    height: 1142,
  },
  "public/life5-web/familia_seg-vida-2.webp": {
    widths: [400, 800],
    width: 1100,
    height: 926,
  },
  "public/life5-web/life5-senior.webp": {
    widths: [400, 800],
    width: 1100,
    height: 482,
  },
  "public/life5-web/seguro-vida-parejas-life5.webp": {
    widths: [400, 800],
    width: 1032,
    height: 1518,
  },
};

export default imageVariants;
